import { useParams } from 'react-router-dom';
import LibModal from '../../../../features/LibModal/LibModal';
import NotFound from '../../../../features/NotFound/NotFoundPage';
import PageTables from './Components/PageTables';
import ProductInfo from './Components/ProductInfo';
import AddPackageModal from './Modals/AddPackageModal';
import AddPackagePriceModal from './Modals/AddPackagePriceModal';
import AddPackageServiceModal from './Modals/AddPackageServiceModal';
import EditProductModal from './Modals/EditProductModal';
import ProductDetailsProvider, { useProductDt } from './ProductDetailsProvider';

function PageContent() {
    const {
        openModal,
        closeModal,
        modalType,
        modalData,
        productInfo,
        handleReload,
        packageInfo,
        isSelected,
        isClicked
    } = useProductDt();

    if (productInfo && Object.keys(productInfo).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="No Product Found!"
                    btnTitle="Back to list"
                    path="/settings/products"
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <>
            <ProductInfo />
            <PageTables
                openModal={openModal}
                productInfo={productInfo}
                isSelected={isSelected}
                isClicked={isClicked}
                packageInfo={packageInfo}
            />

            {/* modals */}
            {modalType === 'editProduct' && (
                <LibModal title="Edit Product" setOpen={closeModal}>
                    <EditProductModal
                        data={modalData}
                        handleReload={handleReload}
                        closeEditProductModal={closeModal}
                    />
                </LibModal>
            )}
            {modalType === 'addPackage' && (
                <LibModal title="Add Package" setOpen={closeModal}>
                    <AddPackageModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        data={productInfo}
                    />
                </LibModal>
            )}
            {modalType === 'addPrice' && (
                <LibModal title="Add Package Price" setOpen={closeModal}>
                    <AddPackagePriceModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        data={packageInfo}
                    />
                </LibModal>
            )}
            {modalType === 'addService' && (
                <LibModal title="Add Package Service" setOpen={closeModal}>
                    <AddPackageServiceModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        data={packageInfo}
                    />
                </LibModal>
            )}
        </>
    );
}

function ProductDetailsPage() {
    const { productId } = useParams();
    return (
        <ProductDetailsProvider productId={productId}>
            <div className="products-setting inner_page_cont">
                <PageContent />
            </div>
        </ProductDetailsProvider>
    );
}

export default ProductDetailsPage;
